export const isScheduleOnly = (organization) => organization?.subscription === 'ScheduleOnly';
export const isFullAccessOrganization = (organization) => organization?.subscription === 'Full';

//* the flag defaults to true — an absent value (pre-migration) must read as enabled
export const isAvailabilityEnabled = (locationSettings) =>
  locationSettings?.availabilityCalendar !== false;

const KIOSK_TOGGLES = ['kioskMode', 'kioskModeMobile'];

const AVAILABILITY_TOGGLES = [
  'remoteKiosk',
  'editPTO',
  'availabilityRead',
  'availabilityFullAccess',
  'availabilityPeopleEdit',
  'availabilityEquipmentEdit',
  'holidaysCreate',
  'holidaysEdit',
];

//* hidden ⇒ dropped from the saved permissions, which is how "hidden ⇒ turned off" is stored
export const getHiddenPermissions = (locationSettings) =>
  isAvailabilityEnabled(locationSettings) ? [] : AVAILABILITY_TOGGLES;

//* hidden but never rewritten — kiosk is blocked by the subscription, not by these flags, so the stored value must survive
export const getPreservedPermissions = (organization) =>
  isScheduleOnly(organization) ? KIOSK_TOGGLES : [];
